export default {
  user: null,
  userLoginStatus: null,
  userLoginError: null,
}